/* eslint-disable camelcase */
const React = require('react');
const { useEffect, useState } = require('react');

const { CSAT, getFeedbackBaseAPIURL } = require('dx-feedback-utils');
const restclient = require('nordic/restclient');

exports.FeedbackCSAT = ({ i18n, site_id, user_id, email, lang, loginCallbackUrl }) => {
  const [ toggle, setToggle ] = useState(false);
  
  useEffect(() => {
    setToggle(typeof window !== 'undefined' && window.location.hash === '#toggle-feedback');
  }, []);

  if (!toggle) {
    return null;
  }

  const sendCSATFeedback = data => {
    const request = restclient({
      timeout: 5000,
      baseURL: getFeedbackBaseAPIURL(window.location.host),
    });

    Object.assign(data, {
      site_id,
      user_id,
    });

    request.post('/feedback', {
      data,

      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  };

  const acceptContactEmail = () => {
    const baseURL = '/developers/api';

    const request = restclient({
      baseURL,
      timeout: 5000,
    });

    request.post('/contact', {
      data: {
        id: user_id,
        developer_email: email,
        lang,
      },

      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
  };

  return (
    <CSAT
      i18n={i18n}
      email={email}
      loginhref={`https://www.mercadolibre.com/jms/${site_id.toLowerCase()}/lgz/login?platform_id=mp&go=${loginCallbackUrl}`}
      gaprops="MPDEVELOPERS|HEADER_LOGIN"
      onAcceptEmail={acceptContactEmail}
      onSend={sendCSATFeedback}
    />
  );
};
